import WifiOffOutlined from '@material-ui/icons/WifiOffOutlined'
import { Typography } from 'opensolar-ui'
import { useChatDrawerStyles } from '../ChatDrawer.styles'

const DisconnectedBanner = () => {
  const classes = useChatDrawerStyles()

  return (
    <div style={{ background: 'white' }}>
      <div className={classes.disconnectedBanner}>
        <div className={classes.bannerContent}>
          <div className={classes.bannerHeader}>
            <WifiOffOutlined className={classes.disconnectedIcon} />
            <Typography textVariant="subtitle1Bold">Ada Disconnected</Typography>
          </div>
          <span style={{ textAlign: 'left', fontSize: '12px', fontWeight: 400 }}>
            We're having trouble connecting to Ada. Auto-reconnect is active - please wait or check your connection.
          </span>
        </div>
      </div>
    </div>
  )
}

export default DisconnectedBanner
